<template src="./template.html"></template>
<script>
import iframeWidgetBaseMixin from 'mixins/iframeWidgetBase'
import CheckoutModal from 'components/CheckoutModal'
import iframeLib from 'lib/iframe'
import IFRAME_MESSAGE_TYPES from 'shared/constants/iframeMessageTypes'
import config from 'src/config'

export default {
  name: 'checkout-modal-widget',
  mixins: [iframeWidgetBaseMixin],
  data() {
    return {
      eventId: this.$route.query.eventId,
      attributionId: this.$route.query.attributionId,
      affiliateId: this.$route.query.affiliateId,
      trackingId: this.$route.query.trackingId,
    }
  },
  methods: {
    showModal(message) {
      if (message && message.data && message.data.data) {
        const promises = [this.$store.dispatch('getVenue', message.data.data.venueId), this.$store.dispatch('getCurrentLayoutSections', message.data.data.venueId)]

        const checkoutModalType = message.data.data.type
        const eventId = this.eventId || message.data.data.eventId
        const attributionId = this.attributionId || message.data.data.attributionId
        const affiliateId = this.affiliateId || message.data.data.affiliateId
        const trackingId = this.trackingId || message.data.data.trackingId

        if (eventId) {
          promises.push(this.$store.dispatch('setConfigEventId', eventId))
        }

        if (attributionId) {
          promises.push(this.$store.dispatch('setConfigAttributionId', attributionId))
        }

        if (affiliateId) {
          promises.push(this.$store.dispatch('setConfigAffiliateId', affiliateId))
        }

        if (trackingId) {
          promises.push(this.$store.dispatch('setConfigTrackingId', trackingId))
        }

        Promise.all(promises).then(() => {
          this.$refs.checkoutModal.showModal(checkoutModalType, message.data.data)

          return null
        })
      }
    },
    onUpdated() {},
    onClosed() {
      this.$store.dispatch('clearCheckoutCartItems')

      iframeLib.publish(
        {
          name: config.IFRAME_MESSAGE_NAME,
          type: IFRAME_MESSAGE_TYPES.MODAL_CLOSED,
          iframeId: this.iframeId,
          data: {},
        },
        {
          parent: true,
        }
      )
    },
    onBookingCompleted(booking) {
      iframeLib.publish(
        {
          name: config.IFRAME_MESSAGE_NAME,
          type: IFRAME_MESSAGE_TYPES.BOOKING_COMPLETED,
          iframeId: this.iframeId,
          data: {
            booking,
          },
        },
        {
          parent: true,
        }
      )
    },
    onCheckoutSessionCreated(session) {
      iframeLib.publish(
        {
          name: config.IFRAME_MESSAGE_NAME,
          type: IFRAME_MESSAGE_TYPES.REDIRECT,
          iframeId: this.iframeId,
          data: {
            location: session.url,
          },
        },
        {
          parent: true,
        }
      )
    },
  },
  components: {
    CheckoutModal,
  },
  created() {
    iframeLib.subscribe('message', (message) => {
      if (message && message.data && message.data.name === config.IFRAME_MESSAGE_NAME && message.data.iframeId === this.iframeId) {
        if (message.data.type === IFRAME_MESSAGE_TYPES.SHOW_MODAL) {
          if (!message.data.data.venueId) throw new Error('message.data.data.venueId')

          this.showModal(message)
        }
      }
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Widgets/CheckoutModal/index.vue